import React, { useEffect } from 'react';
import { FieldValues } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getProfileAction, signIn } from '../../actions/auth';
import img from '../../assets/images/login.svg';
import logo from '../../assets/images/logo-full.svg';
import SignInForm from '../../components/form/AuthForm/SignInForm';

import styles from './signin.module.scss';

const SignIn = () => {
  const { user, error } = useSelector((d: any) => d.authReducer);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      getProfileAction(dispatch);
    }
  }, []);

  useEffect(() => {
    if (user?.role) {
      navigate('/client?view=card');
    }
  }, [user]);

  function submit(data: FieldValues) {
    signIn(dispatch, data);
  }

  return (
    <div className={styles.signin}>
      <div className={styles.picture}>
        <img src={img} alt="login" />
      </div>
      <div className={styles.content}>
        <div className={styles.form}>
          <div className={styles.logo}>
            <img src={logo} alt="logo" />
          </div>
          <SignInForm
            forgotPwdLink="/forgot-password"
            errorMessage={error}
            submit={submit}
          />
        </div>
      </div>
    </div>
  );
};

export default SignIn;
